import { render, staticRenderFns } from "./ProductInfoForm.vue?vue&type=template&id=34be13b0&"
import script from "./ProductInfoForm.vue?vue&type=script&lang=js&"
export * from "./ProductInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports